import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const files = require.context('assets', true, /\.svg$/);

function SVG({ src, className, elementType, ...passedProps }) {
  const svg = files(`./${src}`);

  const ElementType = elementType || 'div';

  return (
    <ElementType
      {...passedProps}
      className={classNames('embedded-svg', className)}
      dangerouslySetInnerHTML={ { __html: svg } }
    />
  );
}

SVG.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  elementType: PropTypes.string
};

export default SVG;



// WEBPACK FOOTER //
// ./app/components/widgets/icons/svg.js